(function ($) {

    $(document).ready(function () {
        $('.prod-detail__details>.prod-detail__column>p').addClass('correct-style');

        $(".hl-products__items").slick({
            arrows: false,
            dots: false,
            infinite: false,
            appendDots: ".hl-products__navigation",
            appendArrows: ".hl-products__navigation",
            prevArrow: "<a class=\"slider__prev\">\n" +
                "<svg data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56.69 11.69\">" +
                "<path d=\"M56.36 5.5L51.19 0l-.73.69 4.38 4.65H0v1h54.84L50.46 11l.73.69 5.17-5.51.33-.34-.33-.34z\"/>" +
                "</svg>" +
                "Prev" +
                "</a>",
            nextArrow: "<a class=\"slider__next\">\n" +
                "Next" +
                "<svg data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56.69 11.69\">" +
                "<path d=\"M56.36 5.5L51.19 0l-.73.69 4.38 4.65H0v1h54.84L50.46 11l.73.69 5.17-5.51.33-.34-.33-.34z\"/>" +
                "</svg>" +
                "</a>",
            slidesToShow: 5,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        arrows: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 641,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                        dots: true,
                        infinite: true
                    }
                },
                {
                    breakpoint: 401,
                    settings: {
                        slidesToShow: 1,
                        arrows: true,
                        dots: true,
                        infinite: true
                    }
                }
            ]
        });

        $(".logo-gallery.no-slider-desktop .gallery .row:not(.overview)").slick({
            arrows: false,
            dots: false,
            variableWidth: true,
            centerMode: true,
            slidesToShow: 7,
            slidesToScroll: 1,
            autoplaySpeed: 2000,
            autoplay: true,
            infinite: false,

            responsive: [
                {
                    breakpoint: 20000,
                    settings: "unslick"
                },
                {
                    breakpoint: 992,
                    settings: {
                        variableWidth: true,
                        centerMode: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        autoplaySpeed: 2000,
                        autoplay: true,
                        infinite: true
                    }
                }
            ]
        });

        $(".logo-gallery:not(.no-slider-desktop) .gallery .row:not(.overview)").slick({
            arrows: false,
            dots: false,
            variableWidth: true,
            centerMode: true,
            slidesToShow: 7,
            slidesToScroll: 1,
            autoplaySpeed: 2000,
            autoplay: true,
            infinite: true,

            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        centerMode: true,
                        slidesToShow: 3
                    }
                }
            ]
        });
        
        $(".related__products").slick({
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 5,
            responsive: [
                {
                    breakpoint: 20000,
                    settings: "unslick"
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        autoplay: false
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        autoplay: true
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        autoplay: true
                    }
                }
            ]
        });

        $(".hero-product__slider").slick({
            arrows: true,
            dots: true,
            fade: true,
            adaptiveHeight: true,
            appendDots: ".hero-product__navigation-wrapper",
            appendArrows: ".hero-product__navigation-wrapper",
            prevArrow: "<a class=\"slider__prev\">\n" +
                "<svg data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56.69 11.69\">" +
                "<path d=\"M56.36 5.5L51.19 0l-.73.69 4.38 4.65H0v1h54.84L50.46 11l.73.69 5.17-5.51.33-.34-.33-.34z\"/>" +
                "</svg>" +
                "Prev" +
                "</a>",
            nextArrow: "<a class=\"slider__next\">\n" +
                "Next" +
                "<svg data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56.69 11.69\">" +
                "<path d=\"M56.36 5.5L51.19 0l-.73.69 4.38 4.65H0v1h54.84L50.46 11l.73.69 5.17-5.51.33-.34-.33-.34z\"/>" +
                "</svg>" +
                "</a>"
        });
        
        $(".prod-detail__image").slick({
            autoplay: true,
            arrows: true,
            dots: true,
            fade: false,
            appendDots: ".prod-detail__slider-controls",
            appendArrows: ".prod-detail__slider-controls",
            prevArrow: "<a class=\"slider__prev\">\n" +
                "<svg data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56.69 11.69\">" +
                "<path d=\"M56.36 5.5L51.19 0l-.73.69 4.38 4.65H0v1h54.84L50.46 11l.73.69 5.17-5.51.33-.34-.33-.34z\"/>" +
                "</svg>" +
                "Prev" +
                "</a>",
            nextArrow: "<a class=\"slider__next\">\n" +
                "Next" +
                "<svg data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56.69 11.69\">" +
                "<path d=\"M56.36 5.5L51.19 0l-.73.69 4.38 4.65H0v1h54.84L50.46 11l.73.69 5.17-5.51.33-.34-.33-.34z\"/>" +
                "</svg>" +
                "</a>"
        });
    });

})(jQuery);